import AuthBg from "../Assets/Images/bg-auth.png";
import AuthPattern from "../Assets/Images/pattern-auth.png";
import AuthLogo from "../Assets/Images/logo-auth.png";

function LayoutAuth(props) {
  return (
    <div className="layout-auth h-screen flex justify-center items-center">
      <div
        className="w-3/5 h-screen flex justify-center items-center"
        style={{ backgroundImage: `url(${AuthBg})` }}
      >
        <img src={AuthPattern} className="h-[calc(100vh-100px)]" alt="hello" />
      </div>
      <div className="w-2/5 grid justify-center items-center text-center">
        <div>
          <img src={AuthLogo} className="h-[178px] mx-auto" alt="logo" />
        </div>
        {props?.children}
      </div>
    </div>
  );
}

export default LayoutAuth;
